// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "430f13c64900d706","396": "ed339af2f868adcd","460": "bf1274c9155eb93f","498": "9c2cf4fa3ff1c3f7","917": "b794b272c1437656","985": "a80115b47bdfe7f3",}[chunkId] + ".chunk.js"
}